<template>
    <div>
        
        <PageTitle v-bind:title="title" v-bind:admin="true" />

        <!-- Add Item form -->       
        <button type="button" class="btn btn-primary" @click.prevent="showAddForm">+ Новая Кафедра</button>
        <div class="modal fade" id="addForm" tabindex="-1" role="dialog" aria-labelledby="exampleModalLabel" aria-hidden="true">
            <div class="modal-dialog">
                <div class="modal-content">
                    <div class="modal-header">
                        <h5 class="modal-title" id="exampleModalLabel">Новая Кафедра</h5>
                        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                        <span aria-hidden="true">&times;</span>
                        </button>
                    </div>
                    <div class="modal-body">
                        <!-- <form> -->
                        <div class="form-group">
                            <label for="name" class="col-form-label">Наименование:</label>
                            <input type="text" class="form-control" id="name" name="name" v-model="name">
                            <div class="alert alert-danger" v-if="errors.validationAdd && errors.validationAdd.name">
                                {{ errors.validationAdd.name[0] }}
                            </div>
                        </div>
                        <!-- </form> -->
                    </div>
                    <div class="modal-footer">
                        <button type="button" class="btn btn-secondary" @click.prevent="cancelAdding">Отмена</button>
                        <button type="button" class="btn btn-primary" @click.prevent="addRecord">Сохранить</button>
                    </div>
                    <div class="alert alert-danger" v-if="errors.add">
                        {{ errors.add }}
                    </div>
                </div>
            </div>
        </div>
        <!-- END of Add Item form -->


        <div class="alert alert-danger" v-if="errors.load">
            {{ errors.load }}
        </div>
        <Loader v-if="loading" />
        <div v-else-if="data.length">
            <div class="alert alert-danger" v-if="errors.delete">
                {{ errors.delete }}
            </div>
            <table class="table">
                <thead>
                    <tr>
                        <th>id</th>
                        <th>Наименование</th>
                        <th></th>
                        <th></th>
                    </tr>
                </thead>
                <tbody>
                    <tr v-for="item in data" :key="item.id">
                        <td>{{ item.id }}</td>
                        <td>{{ item.name }}</td>
                        <td>
                            <form @submit.prevent="deleteRecord(item.id)">
                                <button type="submit" class="btn btn-danger">Удалить</button>
                            </form>
                        </td>
                        <td>
                            <router-link class="btn btn-primary" :to="{ name: 'adminDepartment_edit', params: { id: item.id } }">Редактировать</router-link>
                        </td>
                    </tr>
                </tbody>
            </table>
        </div>

    </div>
</template>
<script>
import axios from 'axios'
import Loader from '@/components/Loader'
import jQuery from 'jquery'
import PageTitle from '@/components/PageTitle'
export default {
    data() {
        return {
            loading: true,
            data: [],
            id: 0,
            name: '',
            description: '',
            image: '',
            errors: {load: '', add: '', delete: '', validationAdd: {}},
            title: 'Список кафедр',
        }
    },
   async mounted() {
       this.loadRecords()
    },
    methods: {

        clearErrors() {
            this.errors.load = '';
            this.errors.add = '';
            this.errors.delete = '';
        },

        async loadRecords() {
            this.errors.load = ''
            try {
                this.loading = true
                let response = await axios.get('admin/departments')
                this.data = response.data.departments
                this.loading = false
            }
            catch (e) {
                this.errors.load = 'Ошибка при загрузке данных'
            }
        },
        showAddForm() {
            this.name = ''
            this.errors.validationAdd = {}
            this.clearErrors();
            jQuery('#addForm').modal('show')
        },
        cancelAdding() {
            this.name = ''
            jQuery('#addForm').modal('hide')
        },
        //
        // Add new record.
        //
        async addRecord() {
            this.errors.validationAdd = {}
            this.clearErrors();
            try {
                let response = await axios.post('admin/departments', {name: this.name})
                if (response.status == 200) {
                    this.name = ''
                    this.loadRecords()
                    jQuery('#addForm').modal('hide')
                }
            }
            catch(e) {
                if (e.response.status == 422) {
                    this.errors.validationAdd = e.response.data.errors
                }               
                else if (e.response.status == 520) {
                    this.errors.add = "Ошибка при создании записи."
                }
                else {
                    this.errors.add = "Неизвестная ошибка при создании записи."
                }
            }
        },
        //
        // Delete record.
        //
        async deleteRecord(id) {
            this.clearErrors();
            try {
                let response = await axios.delete('admin/departments/'+id)
                if (response.status == 200) {
                    // удаление эл-та из списка "на клиенте":
                    let index = this.data.findIndex(tmpdata => tmpdata.id == id)
                    this.data.splice(index, 1)            
                }
            }
            catch (e) {
                if (e.response.status == 520) {
                    this.errors.delete = e.response.data.error
                }
                else {
                    this.errors.delete = 'Неизвестная ошибка при удалении.'
                }
            } 
        },





    },
    components: {
        Loader,
        PageTitle,
    }
}
</script>